import { render, staticRenderFns } from "./detailForm.vue?vue&type=template&id=7ca7dccb&scoped=true&"
import script from "./detailForm.vue?vue&type=script&lang=js&"
export * from "./detailForm.vue?vue&type=script&lang=js&"
import style0 from "./detailForm.vue?vue&type=style&index=0&id=7ca7dccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7dccb",
  null
  
)

export default component.exports